// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { specificationsStyles } from "@ces/Overrides/Widgets/ProductDetails/ProductDetailsSpecifications";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color, xScreen } from "@ces/XDL/Utilities";
import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import { AccordionSectionHeaderProps } from "@insite/mobius/AccordionSection/AccordionSectionHeader";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

specificationsStyles.specificationsAccordion = {
    headingLevel: 1,
    mergeCss: true,
    css: css`
        ${AccordionSectionPanel}:last-child {
            padding-bottom: 0;
        }
    `,
};

specificationsStyles.specificationsAccordionSection = {
    headerProps: {
        css: css`
            ${({ expanded }: AccordionSectionHeaderProps) =>
                !expanded &&
                css`
                    &:last-of-type {
                        &&& button,
                        &&& button:focus {
                            margin-bottom: 0;
                        }
                    }
                `}
            @media print {
                button {
                    display: block !important;
                }
            }
        `,
    },
    toggleIconProps: {
        css: css`
            ${IconWrapper}, svg {
                width: 15px;
                height: 9px;
                @media print {
                    display: none;
                }
            }
        `,
    },
    panelProps: {
        css: css`
            @media print {
                display: flex;
                width: 100%;
            }
        `,
    },
};

specificationsStyles.specificationSection = {
    css: css`
        margin-top: 8px; // + gap from info container
        display: flex;
        flex-direction: column;
        gap: 5px;
        ${xScreen("lte", "md")} {
            margin-bottom: 44px;
            gap: 11px;
        }
        ${xScreen("lte", "sm")} {
            margin-bottom: 4px;
            margin-top: 0;
            gap: 5px;
        }
    `,
};

specificationsStyles.specificationTitle = {
    variant: "h4",
    css: css`
        margin-bottom: 0;
    `,
};

specificationsStyles.specificationsTableContainer = {
    css: css`
        & > div {
            display: flex;
            gap: 22px;
            ${xScreen("lte", 1312)} {
                flex-wrap: wrap;
            }
            ${xScreen("lte", "md")} {
                flex-wrap: nowrap;
            }
            ${xScreen("lte", "sm")} {
                flex-wrap: wrap;
            }
        }

        table {
            border: none;
            border-collapse: collapse;
            margin: 0 !important;
            height: fit-content;
            width: 100%;
        }
        & table,
        & tbody,
        & tr,
        & td {
            padding: 0;
            border-spacing: 0;
            border: none;
        }
        & tr {
            vertical-align: baseline;
            border-bottom: 1px solid ${color("common.border")};
            & > td:first-child {
                font-size: 14px;
                line-height: 22px;
                font-weight: ${fontConfig.weight.bold};
                padding: 7px 0 9px 0;
                word-break: keep-all;
                width: 91px;
            }
            & > td:last-child {
                font-size: 14px;
                line-height: 22px;
                color: ${color("common.ui5")};
                padding: 7px 0 9px 8px;
                width: 100%;
            }
        }
    `,
};
